<template>
  <Dropdown classMenuItems="w-[180px] top-[40px]">
    <div class="flex items-center">
      <div class="flex-1 ltr:mr-[10px] rtl:ml-[10px]">
        <div class="h-7 w-7 rounded-full">
          <img v-if="userStore.getAvatar"
               :src="userStore.getAvatar"
               alt=""
               class="block w-full h-full object-cover rounded-full"
          />
          <div v-else class="w-7 h-7 rounded-full border border-slate-100 flex items-center justify-center">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                 stroke="#F1F5F9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                 class="lucide lucide-user-icon lucide-user h-6 w-6">
              <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"/>
              <circle cx="12" cy="7" r="4"/>
            </svg>
          </div>
        </div>
      </div>
      <div
          class="flex-none lg:flex-row lg:gap-2 text-slate-600 dark:text-white text-sm font-normal items-center lg:flex hidden overflow-hidden text-ellipsis whitespace-nowrap">
        <span class="overflow-hidden text-ellipsis whitespace-nowrap block">{{ username }}</span>
        <span class="text-base inline-block">
          <Icon icon="heroicons-outline:chevron-down"></Icon>
        </span>
      </div>
    </div>
    <template #menus>
      <MenuItem v-slot="{ active }" v-for="(item, i) in ProfileMenu" :key="i">
        <div
            type="button"
            :class="`${
            active
              ? 'bg-slate-100 dark:bg-slate-700 dark:bg-opacity-70 text-slate-900 dark:text-slate-300'
              : 'text-slate-600 dark:text-slate-300'
          } `"
            class="inline-flex items-center space-x-2 rtl:space-x-reverse w-full px-4 py-2 first:rounded-t last:rounded-b font-normal cursor-pointer"
            @click="item.link()"
        >
          <div class="flex-none text-lg">
            <Icon :icon="item.icon"/>
          </div>
          <div class="flex-1 text-sm">
            {{ $t('menuItems.' + (item.label).toLowerCase()) }}
          </div>
        </div>
      </MenuItem>
    </template>
  </Dropdown>
</template>
<script>
import {MenuItem} from "@headlessui/vue";
import Dropdown from "@/components/Dropdown/index.vue";
import Icon from "@/components/Icon/index.vue";
import profileImg from "@/assets/images/all-img/user-big.png"
import {useUserStore} from "@/stores/user";
import {useLogout} from "@/mixins/logout";
import {useRouter} from "vue-router";
import {computed} from "vue";

export default {
  components: {
    Icon,
    Dropdown,
    MenuItem,
  },
  data() {
    return {
      profileImg,
    };
  },
  setup() {
    const userStore = useUserStore()
    const router = useRouter()
    const {logout} = useLogout()
    const username = computed(() => {
      return userStore.getName
    })
    const ProfileMenu = [
      {
        label: "Profile",
        icon: "heroicons-outline:user",
        link: () => {
          router.push({name: "profile"});
        },
      },
      {
        label: "Settings",
        icon: "heroicons-outline:cog",
        link: () => {
          router.push("settings");
        },
      },
      {
        label: "Logout",
        icon: "heroicons-outline:logout",
        link: () => {
          //router.push({name: "Login"});
          logout();
          localStorage.removeItem("activeUser");
        },
      },
    ];

    return {
      userStore,
      ProfileMenu,
      username
    }
  }
};
</script>
<style lang=""></style>
